import { useRef } from 'react';
export const useHandlerRef = (handler, deps) => {
    const dependencies = useRef(deps);
    const handlerRef = useRef(handler);
    if (dependencies.current !== deps &&
        (dependencies.current.length !== deps.length || dependencies.current.some((dep, i) => dep !== deps[i]))) {
        dependencies.current = deps;
        handlerRef.current = handler;
    }
    return handlerRef;
};
